import { createContext } from "react";

import type { FeatureFlagMap } from "../services/ninetailed/types";

const FeatureFlagContext = createContext<FeatureFlagMap>({});

export default FeatureFlagContext;
